import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import OrganizationForm from "../components/OrganizationForm";
import useOrganization from "../../common/hooks/pages/useOrganization";
import { useAuth } from "../../common/contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../common/helpers/browserStorage";
import { useApp } from "../../common/contexts/AppContext";

function ChooseOrganizationContainer() {
  const navigate = useNavigate();

  const { user, fetchProfile } = useAuth();

  const { setOrganizationId } = useApp();

  const { toast } = usePopup();

  const { createOrganization } = useOrganization();

  const { mutate: createOrg, isLoading } = useMutation({
    mutationFn: createOrganization,
    onSuccess: (res) => {
      const { message, organization } = res?.data;
      setLocalStorage("organizationId", organization?._id);
      setOrganizationId(organization?._id);
      toast(message, "success");
      fetchProfile();

      setTimeout(() => {
        navigate("/pages");
      }, 1000);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating organization!";
      toast(message, "error");
    },
  });

  const { organizationAsOwner, organizationsAsMember } = user || {};

  useEffect(() => {
    if (!getLocalStorage("accessToken")) {
      localStorage.clear();
      navigate("/login");
    } else if (getLocalStorage("organizationId")) {
      navigate("/pages");
    }
  }, []);

  return (
    <div className="bg-gradient-to-r from-purple-900 to-purple-500 h-screen flex flex-col justify-center items-center">
      <OrganizationForm
        createOrganization={(data) => createOrg(data)}
        isCreatingOrganization={isLoading}
        organizationAsOwner={organizationAsOwner}
        organizationsAsMember={organizationsAsMember}
        onSelectingOrganization={(organizationId) => {
          setLocalStorage("organizationId", organizationId);
          setOrganizationId(organizationId);
          navigate("/pages");
        }}
      />
    </div>
  );
}

export default ChooseOrganizationContainer;
